import { Box, AppBar, Toolbar, IconButton, Typography, Tabs, Tab } from "@mui/material";
import TotogiLogoWhiteSvg from "../assets/TotogiLogoWhite.svg";
import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export const MainNavbar: React.FC = () => {
  const location = useLocation();
  const [value, setValue] = useState<string>('/register');

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ background: 'rgb(0, 29, 61)' }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <Box component="img" src={TotogiLogoWhiteSvg} alt="logo" />
          </Typography>
          <Tabs value={value} onChange={(e, newValue) => setValue(newValue)} className="navbar-tabs">
            <Tab 
              label="Coder" 
              value="/coder" 
              component={NavLink} 
              to={"/coder"} 
              sx={{ 
                borderBottom: location.pathname === '/coder' || location.pathname === '/' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                '&:hover': {
                  borderBottom: location.pathname === '/coder' || location.pathname === '/' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                },
                height: '64px'
              }}
            />
            <Tab 
              label="Codebase Index" 
              value="/codebase_index" 
              component={NavLink} 
              to={"/codebase_index"} 
              sx={{ 
                borderBottom: location.pathname === '/codebase_index' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                '&:hover': {
                  borderBottom: location.pathname === '/codebase_index' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                },
                height: '64px'
              }}
            />
            <Tab 
              label="Codebases" 
              value="/codebases" 
              component={NavLink} 
              to={"/codebases"} 
              sx={{ 
                borderBottom: location.pathname === '/codebases' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                '&:hover': {
                  borderBottom: location.pathname === '/codebases' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                },
                height: '64px'
              }}
            />
            <Tab 
              label="Executions" 
              value="/executions" 
              component={NavLink} 
              to={"/executions"} 
              sx={{ 
                borderBottom: location.pathname === '/websocket_connections' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                '&:hover': {
                  borderBottom: location.pathname === '/websocket_connections' ? '4px solid #FF4F58' : '4px solid rgb(0, 29, 61)',
                },
                height: '64px'
              }}
            />
          </Tabs>
        </Toolbar>
      </AppBar>
    </Box>
  );
};